module.exports = __webpack_public_path__ + "media/images/quote-226834447323018205396fb8e878d1c9.png";